
export default class ResponsiveImages {
    constructor() {
        const images = document.querySelectorAll('img[srcset].responsive-image');
        this.updateImageSizes(images);
        this.addLoadEventListeners(images);

        window.addEventListener('resize', () => this.updateImageSizes(images));
    }

    updateImageSizes(images) {
        images.forEach(img => {
            img.sizes = img.offsetWidth + 'px';
        });
    }

    addLoadEventListeners(images) {
        images.forEach(img => {
            if (!img.complete) img.classList.add('blur');
            img.addEventListener('load', (e) => {
                e.target.classList.remove('blur');
                e.target.classList.add('loaded');
            });
        });
    }
}
